import axios from 'axios';

export const externalapi = axios.create({
  baseURL: process.env.REACT_APP_EXTERNAL_HUB_BASE || "https://hub.brainymed.com/",
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});
